export const TARGET_COLLEGES_ENDPOINT = '/v1/cpp/target-colleges';
export const SUBSCRIPTIONS_PATH = '/subscriptions';
export const RESUME_POWER_POPUP_COPY = 'Resume Power to access College Prospect Portal';

const formatP6 = (value) => {
    if (value === null || value === undefined) {
        return null;
    }
    return Number(value).toFixed(2);
};

export const mapResponseToRow = (item) => ({
    id: item.clubId,
    name: item.name,
    clubProfileImages: item.clubProfileImages,
    p6: formatP6(item.p6),
    division: item.div,
    conference: item.conf,
    isAlerted: !!item.isAlertActive,
});
